'use strict'; // jshint ignore:line

// import deepmerge from 'deepmerge';
const util = {};

util.format_time_elapsed = function( then ){
   const now = new Date();
   const time_elapsed = now - then;
   const seconds = Math.round( time_elapsed/1000 );

   if( time_elapsed <= 30000  ){
      return 'Just now';
   }

   if( time_elapsed <= 60000  ){
      return `${seconds} seconds ago`;
   }

   const minutes = Math.round( time_elapsed/1000/60 );

   if( time_elapsed <= 3600000  ){
      return `${minutes} minute${util.pluralize( minutes, 's' )} ago`;
   }

   if( time_elapsed <= 86400000  ){
      const hour_then = util.format_hour( then.getHours() );
      const minutes_then = ''.concat( then.getMinutes() ).padStart( 2, '0') ;
      const ampm_then = util.format_ampm( then.getHours() );
      return `${hour_then}:${minutes_then} ${ampm_then}`;
   }

   
   return util.format_datetime_local( then );
};// /format_time_elapsed()

util.format_hour = function( n ){
   if( n > 12 ){
      return n - 12;
   }

   return n;
};// /format_hour()

util.format_ampm = function( n ){
   if( n >= 12 ){
      return 'PM';
   }

   return 'AM';
};// /format_ampm()

util.pluralize = function( n, c ){
   if( n == 1 ){
      return '';
   }

   return c;
};// /pluralize()

// util.extend_deep = function() {
//    return deepmerge.apply( deepmerge, arguments );
// };// /extend_deep()


util.format_datetime = function( o_date ){
   var a_date = [
      ''.concat( o_date.getMonth()+1 ).padStart( 2, '0' ),
      ''.concat( o_date.getDate() ).padStart( 2, '0' ),
      ''.concat( o_date.getFullYear() ).padStart( 2, '0' )
   ];
   var a_time = [
      ''.concat( o_date.getHours() ).padStart( 2, '0' ),
      ''.concat( o_date.getMinutes() ).padStart( 2, '0' ),
      '00'
   ];
   return ''.concat( a_date.join( '/' ), ' ', a_time.join( ':' ) );
};// /format_datetime()

util.format_date_local = function( o_date ){
   var a_date = [
      ''.concat( o_date.getMonth()+1 ).padStart( 2, '0' ),
      ''.concat( o_date.getDate() ).padStart( 2, '0' ),
      ''.concat( o_date.getFullYear() ).padStart( 2, '0' ),
   ];
   return ''.concat( a_date.join( '/' ) );
};// /format_date_local()

util.format_date_ymd = function( o_date ){
   var a_date = [
      ''.concat( o_date.getFullYear() ).padStart( 2, '0' ),
      ''.concat( o_date.getMonth()+1 ).padStart( 2, '0' ),
      ''.concat( o_date.getDate() ).padStart( 2, '0' ),
   ];
   return ''.concat( a_date.join( '-' ) );
};// /format_date_ymd()

util.format_datetime_local = function( o_date ){
   var a_date = [
      ''.concat( o_date.getMonth()+1 ).padStart( 2, '0' ),
      ''.concat( o_date.getDate() ).padStart( 2, '0' ),
      ''.concat( o_date.getFullYear() ).padStart( 2, '0' )
   ];
   var a_time = [
      ''.concat( util.format_hour( o_date.getHours() ) ).padStart( 2, '0' ),
      ''.concat( o_date.getMinutes() ).padStart( 2, '0' ),
      '00'
   ];

   const ampm = util.format_ampm( o_date.getHours() );
   return ''.concat( a_date.join( '/' ), ' ', a_time.join( ':' ), ' ', ampm );
};// /format_datetime_local()

util.optional_chaining = function( o_obj, c_chain ){
   if( typeof o_obj != 'object' ){
      return;
   }

   const a_chain = c_chain.split( '.' );
   const c_prop = a_chain.shift();
   const l_has_prop = Object.prototype.hasOwnProperty.call( o_obj, c_prop );

   if( l_has_prop && a_chain.length > 0 ){
      return util.optional_chaining( o_obj[c_prop], a_chain.join( '.' ) );
   }

   if( l_has_prop ){
      return o_obj[c_prop];
   }

   return;
};// /optional_chaining()


// ###-###-###
util.format_phone_local = function( c_phone ){
   var c_digits = ''.concat( c_phone ).replace(/\D/g, '');
   var a_match = c_digits.match(/^(\d{3})(\d{3})(\d{4})$/);

   if( !a_match ){
      return c_phone;
   }

   return ''.concat( a_match[1],'-', a_match[2],'-',a_match[3] );
};// /format_phone_local()

// ###-###-###

util.format_phone_dots = function( c_phone ){
   var c_digits = ''.concat( c_phone ).replace(/\D/g, '');
   var a_match = c_digits.match(/^(\d{3})(\d{3})(\d{4})$/);

   if( !a_match ){
      return c_phone;
   }

   return ''.concat( a_match[1],'.', a_match[2],'.',a_match[3] );
};// /format_phone_dots()

util.to_slug = function(text) {
   return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      // .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      // .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/[^\w-]+/g, '')       // Remove all non-word chars
      .replace(/--+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
};// /to_slug()

util.clone = function( item ) {
   return JSON.parse( JSON.stringify( item ) );
};// /clone()

util.get_caught_error = function( o_caught_error ){
   const c = util.optional_chaining;
   const n_code = c( o_caught_error, 'response.data.error.code' ) ||
      c( o_caught_error, 'response.status' );
   const c_msg = c( o_caught_error, 'response.data.message' ) || 
      c( o_caught_error, 'response.statusText' ) ||
      o_caught_error.message ||
      `${o_caught_error}`;

   return {
      code: n_code,
      message: c_msg,
   };
};// /get_caught_error()

util.uuidv4 = function() {
   return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
   });
};// /uuidv4()

util.uid = function() {
   const c_time = new Date().getTime();
   const c_rand = 'xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
   });
   return [
      c_time,
      ++util.uid._count,
      c_rand,
   ].join( '-' );
};// /uid()
util.uid._count = 0;




util.array_unique = function(){
   const arrays = [].slice.call( arguments );
   const merged = [].concat.apply( [], arrays );
   return merged.filter(function( v, i, a ){
      return a.indexOf( v ) === i;
   });
};/// /util()

export default util;
